<template>

</template>
<script>
  const midKey = "MIDDIALOG_STORAGE_KEY";
  import { getNoticeDetailUrl } from "utils/notices";
  const namePrefix = "midNotice";
  export default {
      props: {
          notices: {
              type: Array,
              required: true
          }
      },
      created() {
          this.noticesHasRead = [];
          this.noticesShowing = [];
          if (window.localStorage) {
              try {
                  let noticesHasReadStr = window.localStorage.getItem(midKey);
                  if (noticesHasReadStr) {
                      this.noticesHasRead = JSON.parse(noticesHasReadStr);
                  }
              } catch (ex) {
                  console.error(err);
              }
          }
          if (this.notices && this.notices.length) {
              let noticeUnread = this.notices.find(noticeItem => {
                  return !this.noticesHasRead.includes(noticeItem.announceId);
              });
              if (noticeUnread) {
                  this.showMidNotice(noticeUnread);
              }
          }
      },
      methods: {
          markAsRead(id) {
              window.open(getNoticeDetailUrl(id), "_blank");
              if (!this.noticesHasRead.includes(id)) {
                  this.noticesHasRead.push(id);
                  if (window.localStorage) {
                      try {
                          window.localStorage.setItem(
                              midKey,
                              JSON.stringify(this.noticesHasRead)
                          );
                      } catch (err) {
                          console.error(err);
                      }
                  }
              }
          },
          showMidNotice(item) {
              if (this.noticesShowing.indexOf(item.announceId) !== -1) {
                  return;
              }
              this.noticesShowing.push(item.announceId);
              this.$Modal.info({
                  title: item.decorateTitle,
                  content: item.decorateContent,
                  name: namePrefix + item.announceId,
                  okText: "查看详情",
                  maskClosable: false,
                  closable: false,
                  onOk: () => {
                      this.$nextTick(() => {
                          this.noticesShowing.splice(
                              this.noticesShowing.indexOf(item.announceId),
                              1
                          );
                          this.markAsRead(item.announceId);
                      });
                  }
              });
          }
      }
  };
</script>
<style lang='scss'>
.tbo-modal-confirm-head-title {
  font-size: 17px;
}
.tbo-modal-confirm-footer {
  margin-top: 20px !important;
  .tbo-btn-large {
    font-size: 14px !important;
  }
}
</style>



// WEBPACK FOOTER //
// MidNotices.vue?38a853c1